import { render } from "./CheckMark.vue?vue&type=template&id=2dd733d7"
import script from "./CheckMark.vue?vue&type=script&lang=js"
export * from "./CheckMark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__